import React, { useState } from "react";
import { Layout, Menu, Button, Space, Dropdown } from "antd";
import { Link, useLocation } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { Image } from "react-bootstrap";

/* ---------- Assets ---------- */
import anm from "../../assets/images/anm.svg";
import usaFlag from "../../assets/images/usaFlag.svg";
import IndFlag from "../../assets/images/IndFlag.svg";
import FranceFlag from "../../assets/images/FranceFlag.svg";
import UkFlag from "../../assets/images/UkFlag.svg";

/* ---------- Sections ---------- */
import LandingHero from "./LandingHero";
import TrustSection from "./TrustSection";
import PricingPlans from "./PricingPlans";
import Testimonial from "./Testimonial";
import SupportSection from "./SupportSection";
import AISection from "./AiSection";
import SecuritySection from "./SecuritySection";
import PerformanceSection from "./PerformanceSection";
import Review from "./Review";
import BusinessSection from "./BusinessSection";
import MigrationSection from "./MigrationSection";
import Faq from "./Faq";
import Footer from "./Footer";

import "./LandingHome.css";

const { Header, Content } = Layout;

const LandingHome = () => {
  const location = useLocation();

  /* ---------- Language State ---------- */
  const [selectedLang, setSelectedLang] = useState({
    name: "Eng (US)",
    flag: usaFlag,
  });

  /* ---------- Language Dropdown ---------- */
  const languageMenu = {
    items: [
      {
        key: "1",
        label: (
          <div
            onClick={() => setSelectedLang({ name: "Eng (US)", flag: usaFlag })}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontWeight: 600,
            }}
          >
            <img
              src={usaFlag}
              alt="flag"
              style={{ width: 28, height: 28, borderRadius: "50%" }}
            />
            <span>English (US)</span>
          </div>
        ),
      },
      {
        key: "2",
        label: (
          <div
            onClick={() =>
              setSelectedLang({ name: "Hindi (IN)", flag: IndFlag })
            }
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontWeight: 600,
            }}
          >
            <img
              src={IndFlag}
              alt="flag"
              style={{ width: 28, height: 28, borderRadius: "50%" }}
            />
            <span>Hindi (IN)</span>
          </div>
        ),
      },
      {
        key: "3",
        label: (
          <div
            onClick={() =>
              setSelectedLang({ name: "French (FR)", flag: FranceFlag })
            }
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontWeight: 600,
            }}
          >
            <img
              src={FranceFlag}
              alt="flag"
              style={{ width: 28, height: 28, borderRadius: "50%" }}
            />
            <span>French (FR)</span>
          </div>
        ),
      },
      {
        key: "4",
        label: (
          <div
            onClick={() => setSelectedLang({ name: "Eng (UK)", flag: UkFlag })}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontWeight: 600,
            }}
          >
            <img
              src={UkFlag}
              alt="flag"
              style={{ width: 28, height: 28, borderRadius: "50%" }}
            />
            <span>English (UK)</span>
          </div>
        ),
      },
    ],
  };

  /* ---------- Main Menu ---------- */
  const menuItems = [
    { key: "/pricing", label: <Link to="/pricing">Pricing</Link> },
    { key: "/services", label: <Link to="/services">Services</Link> },
    { key: "/dedicated", label: <Link to="/dedicated">Dedicated</Link> },
    { key: "/cloud", label: <Link to="/cloud">Cloud</Link> },
    { key: "/storage", label: <Link to="/storage">Storage</Link> },
    { key: "/vps", label: <Link to="/vps">VPS</Link> },
    {
      key: "/dedicated-server",
      label: <Link to="/dedicated-server">Dedicated Server</Link>,
    },
    {
      key: "/apps-pannels",
      label: <Link to="/apps-pannels">Apps & Panels</Link>,
    },
    {
      key: "more",
      label: (
        <span>
          More <span style={{ fontSize: 12 }}>▼</span>
        </span>
      ),
      children: [
        { key: "/serverless", label: <Link to="/serverless">Serverless</Link> },
        { key: "/docs", label: <Link to="/docs">Docs</Link> },
        { key: "/blog", label: <Link to="/blog">Blog</Link> },
      ],
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* ================= HEADER ================= */}
      <Header className="antd-navbar">
        {/* LOGO */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Image src={anm} alt="ANM Logo" height="30" />
          <Link to="/" style={{ color: "#1E2A53", fontWeight: 700, fontSize: 18,textDecoration:"none" }}>
            ANM
          </Link>
        </div>
        

        {/* MENU */}
        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={menuItems}
          className="antd-menu"
        />

        {/* RIGHT ACTIONS */}
        <Space size="middle" className="nav-actions">
          {/* Language Dropdown */}
          <Dropdown menu={languageMenu} trigger={["hover"]}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                cursor: "pointer",
              }}
            >
              <img
                src={selectedLang.flag}
                alt="lang"
                style={{ width: 24, height: 24, borderRadius: "50%" }}
              />
              <span style={{ fontWeight: 600 }}>{selectedLang.name}</span>
              <DownOutlined style={{ fontSize: 12 }} />
            </div>
          </Dropdown>

          {/* Contact Sales */}
          <Button type="primary" ghost>
            <Link to="/contact-sales">Contact Sales</Link>
          </Button>

          {/* My Account */}
          <Button>
            <Link to="/login">My Account</Link>
          </Button>
        </Space>
      </Header>

      {/* ================= CONTENT ================= */}
      <Content style={{ padding: "16px" }}>
        <LandingHero />
        <TrustSection />
        <PricingPlans />
        <Testimonial />
        <SupportSection />
        <AISection />
        <SecuritySection />
        <PerformanceSection />
        <Review />
        <BusinessSection />
        <MigrationSection />
        <Faq />
        <Footer />
      </Content>
    </Layout>
  );
};

export default LandingHome;
